/* eslint-disable */
function sec2str(t) {
  const d = Math.floor(t / 86400);
  const h = ('0' + Math.floor(t / 3600) % 24).slice(-2);
  const m = ('0' + Math.floor(t / 60) % 60).slice(-2);
  const s = ('0' + t % 60).slice(-2);
  return (
    (d > 0 ? d + 'd ' : '') +
    (h > 0 ? h + ':' : '') +
    (m > 0 ? m + ':' : '') +
    (t > 60 ? s : s + 's')
  );
}
/* eslint-enable */

export default sec2str;



// WEBPACK FOOTER //
// ./app/utils/sec2str.js